import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { isEqual, max } from 'date-fns';
import { get as _get } from 'lodash';
import { Observable } from 'rxjs';

import {
  DashboardClaim,
  DashboardClaimCardData,
  RiskType
} from '@amfam/claim/dashboard/data-access';
import { ClaimUtilService } from '@amfam/claim/shared/utility';
import { OverviewAnalytics } from '@amfam/shared/models';
import { ImpersonateRolesService } from '@amfam/shared/utility/impersonation';
import { CopyService } from '@amfam/shared/utility/shared-services';

@Component({
  selector: 'claims-overview',
  templateUrl: './claims-overview.component.html',
  styleUrls: ['../overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ClaimsOverviewComponent implements OnInit {
  @Input() dashboardClaims: DashboardClaim[];
  @Input() claimsLoading: boolean;

  viewClaimAnalytics = OverviewAnalytics.clickViewClaim;
  claimCardData: DashboardClaimCardData[];
  impersonating$: Observable<boolean>;

  constructor(
    private claimUtilService: ClaimUtilService,
    private copyService: CopyService,
    public roleService: ImpersonateRolesService
  ) {}

  ngOnInit() {
    this.claimCardData = this.dashboardClaims.map((claim: DashboardClaim) => {
      // Setup Impersonaton access
      this.impersonating$ = this.roleService.isAuthorized('view_claim');
      const riskName = this.getRiskName(claim);
      const dates = claim.activities.map(activity => new Date(activity.date));
      const mostRecentDate = max(...dates);
      const mostRecentActivity = claim.activities.find(activity =>
        isEqual(new Date(activity.date), mostRecentDate)
      );
      return {
        claimNumber: _get(claim, 'claimNumber', '').replace(/-/g, ''),
        formattedClaimNumber: this.claimUtilService.formatClaimNumber(
          _get(claim, 'claimNumber', '')
        ),
        fullRiskName: riskName,
        latestActivity: mostRecentActivity
      };
    });
  }

  getRiskName(claim: DashboardClaim): string {
    if (claim.risktype === RiskType.VEHICLE) {
      return _get(claim, 'risk[0].vin')
        ? _get(claim, 'risk[0].year', '') +
            ' ' +
            _get(claim, 'risk[0].make', '') +
            ' ' +
            _get(claim, 'risk[0].model', '')
        : this.copyService.getCopy('claims.fnol.vehicleNotOnPolicy');
    } else if (claim.risktype === RiskType.PROPERTY) {
      // DM: claimsdashboardapi update has risk as an array
      if (Array.isArray(claim.risk)) {
        return _get(claim, 'risk[0].addr1', '');
      } else {
        return _get(claim, 'risk.addr1', '');
      }
    }
    return '';
  }
}
